import { render, staticRenderFns } from "./stocks-details.vue?vue&type=template&id=15b9c369"
import script from "./stocks-details.vue?vue&type=script&lang=js"
export * from "./stocks-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports